import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import Button from "components/ui/Button"
import Image, { isUrl, isSVG } from "components/ui/Image"

function ColumnDarkItem({
  image,
  imageClassName,
  title,
  description,
  linkText,
  linkUrl,
  textAlign = "left",
  trackClick,
}) {
  return (
    <div
      className={cx(
        "w-full",
        textAlign === "center" ? "text-center" : "text-left"
      )}
    >
      <div
        className={cx(
          "mx-auto flex items-center justify-center",
          imageClassName
        )}
      >
        {isUrl(image) || isSVG(image) ? (
          <Image className="h-full" src={image} />
        ) : (
          <Image className="h-full" src={image} objectFit="contain" />
        )}
      </div>
      <div className="text-2xl font-bold text-white">{title}</div>
      {description && (
        <div className="mt-2 text-base text-sage">{description}</div>
      )}
      {linkText && linkUrl && (
        <Button
          href={linkUrl}
          trackClick={trackClick}
          className="mt-4"
          color="ocean"
          size="small"
          outline
        >
          {linkText}
        </Button>
      )}
    </div>
  )
}

ColumnDarkItem.propTypes = {
  /** Image */
  image: PropTypes.shape({}),
  /** Additional image className(s) */
  imageClassName: PropTypes.string,
  /** Title */
  title: PropTypes.string,
  /** Description */
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Button text */
  linkText: PropTypes.string,
  /** Button URL */
  linkUrl: PropTypes.string,
  /** Text alignment */
  textAlign: PropTypes.oneOf(["left", "center"]),
  /** Button click tracking event */
  trackClick: PropTypes.string,
}

export default ColumnDarkItem
